import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../modules/common/OverlayLoader.store';
import { OverlayLoader } from '../components/OverlayLoader';

export const OverlayLoaderContainer = observer((): ReactElement => {
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);
  return <OverlayLoader isVisible={overlayLoaderStore.isOverlayVisible()} />;
});
